import clsx from 'clsx';
import { SvgClose } from '@/components/icons';
import { IWithClassname } from '@/models/common';
import s from './ResetButton.module.scss';

interface Props extends IWithClassname {
  onClick: () => void;
  name?: string;
}

export const ResetButton = ({ onClick, name, className }: Props) => {
  return (
    <button className={clsx(s.resetButton, className)} onClick={onClick}>
      {name || 'Очистить'} <SvgClose />
    </button>
  );
};